export enum StandardNumberType {
  Isbn = "Isbn",
  Issn = "Issn",
  Upc = "Upc",
  Pubnum = "Pubnum",
  Asin = "Asin",
}
export type StandardNumberTypeValue = `${StandardNumberType}`;

export interface StandardNumber {
  id: number;
  type: StandardNumberType | StandardNumberTypeValue;
  data: string;
}
